import type { Config } from '@packages/config/src/default/types';

/**
 * Converts the given Date object to the given time zone
 * @param timeZone The desired time zone (e.g. "Europe/Amsterdam")
 * @returns New date object for the desired time zone that returns the correct local time hours and minutes
 */
export const toLocalTime = (date: Date, timeZone: Config['timeZone'] = 'Europe/Berlin') => {
  const formatter = new Intl.DateTimeFormat([], {
    timeZone,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const dateObj = formatter.formatToParts(date);

  const valueFor = (type: string) => dateObj.find((d) => d.type === type)?.value;
  const dateLocalTimeZoneString = `${valueFor('year')}-${valueFor('month')}-${valueFor('day')}T${valueFor('hour')}:${valueFor('minute')}`;

  return new Date(dateLocalTimeZoneString);
};

/**
 * Converts the Date object that "new Date()" generates to the given time zone
 * @param timeZone The desired time zone (e.g. "Europe/Amsterdam")
 * @returns New date object for the desired time zone that returns the correct local time hours and minutes
 */
export const getLocalTime = (timeZone: Config['timeZone'] = 'Europe/Berlin') =>
  toLocalTime(new Date(), timeZone);
